// src/components/layout/Header.jsx
import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
      <div className="container">

        {/* LOGO SECTION */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img
            src="/harmonia-logo.png"
            alt="Harmonia Logo"
            style={{ width: "40px", height: "40px", marginRight: "10px", borderRadius: "50%" }}
          />
          <strong>Harmonia</strong>
        </Link>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navmenu">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navmenu">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link to="/" className="nav-link">Home</Link>
            </li>
            <li className="nav-item">
              <Link to="/physicians" className="nav-link">Our Physicians</Link>
            </li>
            <li className="nav-item">
              <Link to="/appointments" className="nav-link">Appointments</Link>
            </li>
            <li className="nav-item">
              <Link to="/chatbot" className="nav-link">AI Support</Link>
            </li>
            {user ? (
              <li className="nav-item">
                <button
                  className="btn btn-danger ms-3"
                  onClick={() => {
                    localStorage.removeItem("user");
                    window.location.href = "/";
                  }}
                >
                  Logout
                </button>
              </li>
            ) : (
              <>
                <li className="nav-item">
                  <Link to="/login" className="btn btn-outline-primary ms-3">Login</Link>
                </li>
                <li className="nav-item">
                  <Link to="/register" className="btn btn-primary ms-2">Sign Up</Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
